import { useNavigate } from "react-router-dom";
import { ReactComponent as ChevronLeft } from "assets/images/v2/chevron-left-test.svg";
import "./mobile-loan-context-header.scss";

export interface MobileLoanContextHeaderProps {
  /** Subject property address (or fallback label) shown in the header. */
  readonly address: string;
}

/**
 * US-11 dashboard loan-context header (phone): back + address → `/my-loans`.
 * Application loan-context header remains out of scope (US-24 / US-25).
 */
export default function MobileLoanContextHeader({ address }: MobileLoanContextHeaderProps) {
  const navigate = useNavigate();

  const goToMyLoans = () => {
    navigate("/my-loans");
  };

  return (
    <div className="mobile-loan-context-header" data-testid="mobile-loan-context-header">
      <button
        type="button"
        className="mobile-loan-context-header__back"
        onClick={goToMyLoans}
        aria-label="Back to loans"
        data-testid="mobile-loan-context-header-back"
      >
        <ChevronLeft className="mobile-loan-context-header__back-icon" aria-hidden />
      </button>
      <button
        type="button"
        className="mobile-loan-context-header__address"
        onClick={goToMyLoans}
        aria-label={`Back to loans: ${address}`}
        data-testid="mobile-loan-context-header-address"
      >
        <span className="mobile-loan-context-header__address-text">{address}</span>
      </button>
    </div>
  );
}
